export const accountKeys = {
  all: ["account"] as const,
  profile: () => [...accountKeys.all, "profile"] as const,
  reservations: () => [...accountKeys.all, "reservations"] as const,
  saved: () => [...accountKeys.all, "saved"] as const,
  savedStays: () => [...accountKeys.all, "saved-stays"] as const,
  trips: () => [...accountKeys.all, "trips"] as const,
  reviews: () => [...accountKeys.all, "reviews"] as const,
};
